import { TParamsGetSession, TParamsGetTrack } from "../types"

export const SESSION_ENDPOINTS = {
  getSession: "/session"
}

export const SESSION_KEYS = {
  all: ["session"],
  getSessionWithParams: (params: TParamsGetSession) =>
    [...SESSION_KEYS.all, params] as const
}

export const TRACK_ENDPOINTS = {
  getTrack: "/track"
}

export const TRACK_KEYS = {
  all: ["track"],
  getTrackWithParam: (params: TParamsGetTrack) =>
    [...TRACK_KEYS.all, params] as const
} as const
